import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { SeFeApiModule } from 'se-fe-api';
import { SeFeAuthSupportModule } from 'se-fe-auth-support';
import { SeFeFrameRouterModule } from 'se-fe-frame-router';
import { seFeIconCopy, SeFeIconModule, seFeIconMore, seFeIconWhistleThin } from 'se-fe-icon';
import { SeFeToastModule } from 'se-fe-toast';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { TenantKeyGuard } from './guards/tenant-key.guard';
import { baseHrefProvider } from './services/base-href.provider';


export const config: ApplicationConfig = {
  providers: [
    TenantKeyGuard,
    baseHrefProvider,
    provideHttpClient(),
    provideRouter(appRoutes,
      withRouterConfig({
        onSameUrlNavigation: 'reload', // allow routes to reload components
        paramsInheritanceStrategy: 'always', // all routes get all params
        urlUpdateStrategy: 'eager', // replace url on redirect from guard
      }),
    ),
    provideTranslateService({
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({ prefix: '/assets/i18n/' }),

    }),
    provideAnimations(),
    importProvidersFrom(
      SeFeApiModule.forRoot({ domainEnvironments: environment.domainEnvironments }),
      SeFeFrameRouterModule.forRoot({
        origin: environment.frameRouterOrigin,
      }),
      SeFeAuthSupportModule.forRoot(environment),
      SeFeToastModule,
      SeFeIconModule.include([seFeIconWhistleThin, seFeIconMore, seFeIconCopy]),
    )
  ]
};
